<template>
  <div>
    <RecommendationBundle
      v-if="currentGrade"
      class="mb-32 overflow-hidden"
      :main-product="{
        title: product.title,
        description: product.subTitleElements.join(' - '),
        image: product.images?.[0]?.url,
        productPageLink: product.link,
        grade: currentGrade.backboxGrade,
        price: currentGrade.price || {},
        priceNew: product.priceWhenNew,
        listingId: `${currentGrade.id}`,
        brand: product.trackingDetails.brand,
        category: product.trackingDetails.category3Name,
        id: product.id,
        model: product.model,
        specifications: {},
      }"
      :title="i18n(translations.bundleTitle)"
      @add-to-cart="onBundleAddToCart"
    />

    <RecommendationCarousel
      :options="{
        withCrossedPrice: true,
        withStartingFrom: true,
        withGrade: true,
        withAddToCart: false,
      }"
      :recommendation-query="{
        category: 'cousinsUp',
        scope: 'product',
        scopeId: productId,
        limit: 4,
      }"
      :title="i18n(translations.moreTitle)"
      :trackingData="{
        list: 'cousins 1',
      }"
      @error="onRecommendationsError"
      @loaded="onRecommendationsLoaded"
    />

    <RecommendationCarousel
      :options="{
        withCrossedPrice: true,
        withStartingFrom: true,
        withGrade: true,
        withAddToCart: false,
      }"
      :recommendation-query="{
        category: 'cousinsDown',
        scope: 'product',
        scopeId: productId,
        limit: 4,
      }"
      :title="i18n(translations.crossTitle)"
      :trackingData="{
        list: 'cousins 2',
      }"
    />
  </div>
</template>

<script lang="ts" setup>
import { productAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { Product } from '~/scopes/core/models/product'
import RecommendationBundle from '~/scopes/recommendation/components/RecommendationBundle.vue'
import RecommendationCarousel from '~/scopes/recommendation/components/RecommendationCarousel.vue'

import { useUrlParams } from '../../composables/useUrlParams'

import translations from './Recommendations.translations'

defineProps<{
  product: productAPI.GetProductResponse
  currentGrade: productAPI.GetBestOffersResponse[number] | null | undefined
}>()

const emit = defineEmits<{
  'bundle-add-to-cart': [Array<string>]
  'recommendations-loaded': [Array<Product>]
  'recommendations-error': []
}>()

const i18n = useI18n()
const { productId } = useUrlParams()

function onBundleAddToCart(listings: Array<string>) {
  emit('bundle-add-to-cart', listings)
}

function onRecommendationsLoaded(products: Array<Product>) {
  emit('recommendations-loaded', products)
}

function onRecommendationsError() {
  emit('recommendations-error')
}
</script>
